export const TOGGLE_SUBMENU = 'menu/TOGGLE_SUBMENU';

export const SET_IS_OPEN = 'menu/SET_IS_OPEN';

export const ADD_TO_ACTIVE_TRAIL = 'menu/ADD_TO_ACTIVE_TRAIL';

export const GO_BACK = 'menu/GO_BACK';

export const SET_ACTIVE_TRAIL = 'menu/SET_ACTIVE_TRAIL';

export const TOGGLE_MOBILE_MENU = 'menu/TOGGLE_MOBILE_MENU';
